"use client";

import { c as _c } from "react/compiler-runtime";
import { QueryClientProvider, QueryClient } from "@tanstack/react-query";
import { useState } from "react";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
const ReactQueryProvider = t0 => {
  const $ = _c(4);
  const {
    children
  } = t0;
  const [queryClient] = useState(_temp);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <ReactQueryDevtools initialIsOpen={false} />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== children || $[2] !== queryClient) {
    t2 = <QueryClientProvider client={queryClient}>{children}{t1}</QueryClientProvider>;
    $[1] = children;
    $[2] = queryClient;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};
export default ReactQueryProvider;
function _temp() {
  return new QueryClient();
}